define("shared/components/shared/modal/section", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class={{concat-classes (if @hasSecondary "has--secondary") this.primaryClass}}
    data-test-id="modal-card"
    ...attributes
  >
    {{#if @header}}
      {{component @header}}
    {{/if}}
    {{#if this.closeIcon}}
      <Shared::Ui::Button
        @onClick={{@close}}
        @variant="unstyled"
        aria-label={{t "shared_words.close"}}
        class={{concat-classes "o--modal--closeIcon" @closeButtonQaClass}}
        id="close-modal"
        type="button"
      >
        {{svg-jar "close" class="o--icon--md o--icon--white"}}
      </Shared::Ui::Button>
    {{/if}}
    {{yield}}
  </div>
  */
  {
    "id": "FjMSYFPY",
    "block": "[[[11,0],[16,0,[28,[37,0],[[52,[30,1],\"has--secondary\"],[30,0,[\"primaryClass\"]]],null]],[24,\"data-test-id\",\"modal-card\"],[17,2],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"    \"],[46,[30,3],null,null,null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"closeIcon\"]],[[[1,\"    \"],[8,[39,3],[[16,\"aria-label\",[28,[37,4],[\"shared_words.close\"],null]],[16,0,[28,[37,0],[\"o--modal--closeIcon\",[30,4]],null]],[24,1,\"close-modal\"],[24,4,\"button\"]],[[\"@onClick\",\"@variant\"],[[30,5],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"close\"],[[\"class\"],[\"o--icon--md o--icon--white\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[18,6,null],[1,\"\\n\"],[13]],[\"@hasSecondary\",\"&attrs\",\"@header\",\"@closeButtonQaClass\",\"@close\",\"&default\"],false,[\"concat-classes\",\"if\",\"component\",\"shared/ui/button\",\"t\",\"svg-jar\",\"yield\"]]",
    "moduleName": "shared/components/shared/modal/section.hbs",
    "isStrictMode": false
  });
  class SectionComponent extends _component2.default {
    get closable() {
      return this.args.closable ?? true;
    }
    get closeIcon() {
      if (this.args.closeIcon !== undefined) {
        return this.args.closeIcon;
      }
      return this.args.close && this.closable;
    }
    get primaryClass() {
      if (this.args.primaryClass) {
        return this.args.primaryClass;
      }
      return this.args.portrait ? 'o--modalCard--narrow' : 'o--modalCard';
    }
  }
  _exports.default = SectionComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SectionComponent);
});